//export const MAIN_API_BASE = "/api";
export const MAIN_API_BASE = "https://novachain2-backend.onrender.com/api";
export const ADMIN_API_BASE = "https://novachain2-admin-backend.onrender.com";